import { useMutation } from "react-query";
import { addDVRType } from "../../../../../actions/Utilities/DVRType";
import { toast } from "components/toastNotification";
import { IDVRType } from "../types";
import { addStateDVRType, dvrTypeReFetching } from "../atoms/atoms";
import { useRecoilState, useSetRecoilState } from "recoil";

const useAddDVRType = () => {
  const setActionAddState = useSetRecoilState(addStateDVRType);
  const [isReFetching, setIsReFetching] = useRecoilState(dvrTypeReFetching);
  const { mutate } = useMutation((NewData: IDVRType) => addDVRType(NewData), {
    onSuccess: (res: any) => {
      if (typeof res == "object") {
        toast.fire("Adding DVR Type failed", res.Message, "error");
      } else {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "DVR Type Added Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `DVR Type Added Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Adding DVR Type failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Adding DVR Type failed",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire("Adding DVR Type failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Adding DVR Type failed", res, "error");
        }
      }
      // Redirect to View
      setActionAddState(false);

      // ReFetch Data
      setIsReFetching(isReFetching ? false : true);
    },

    onError: (error: any) => {
      toast.fire("Add DVR Type failed", `Error: ${error}`, "error");
    },
  });

  return mutate;
};
export default useAddDVRType;
